import Api from "js/core/api";
import { loadImage } from "js/core/utilities/promiseHelper";
import log from "../logger";

class Logos {
    static async getSignedUrlAndLoad(id, ignoreCache = false) {
        log.info(log.LOGO)(`getSignedUrlAndLoad() id: ${id} ignoreCache: ${ignoreCache}`);

        if (window.isOfflinePlayer) {
            const url = `/userData/logos/${id}`;
            await loadImage(url);
            return url;
        }

        const { url } = await Api.logos.get({ id }, ignoreCache);
        try {
            await loadImage(url);
        } catch (err) {
            if (ignoreCache) {
                throw err;
            }

            log.info(log.LOGO)(`getSignedUrlAndLoad() failed to load logo with id ${id}, fetching a new url without cache and trying again`);
            return this.getSignedUrlAndLoad(id, true);
        }
        return url;
    }

    static async getWriteSignedUrl(id) {
        log.info(log.LOGO)(`getWriteSignedUrl() id: ${id}`);

        const { url } = await Api.logos.get({ id, action: "write" }, true);
        return url;
    }
}

module.exports = Logos;
